import { ResponseBase } from "@/services/types"
import { shopCLient } from "../../axiosConfig"

export interface ShopParams {
  categoryId?: string
  subCategoryId?: string
  minPrice?: string
  maxPrice?: string
  nameMn?: string
  nameEn?: string
  giftMn?: string
  sale?: string
  priceDesc?: string
  priceAsc?: string
}
export interface ProductMin {
  id: number
  documentId: string
  nameMn?: string
  nameEn: string
  price: number
  listPrice: number
  colors: Colors[]
  storages: string[]
  storage: string
  productColor: Color
  images: string[]
  size: string
  smsId: string
  coverImage: string
  categoryId: number
  subCategoryId: number
  productState: ProductState[]
  leasingGroupId: number
}

export interface ProductState {
  id: number
  nameMn: string
  nameEn: string
  borderHexcode: string
  iconHexcode: string
  icon: string
  textHexcode: string
  bgHexcode: string
  borderHexcodeDark: string
  iconHexcodeDark: string
  textHexcodeDark: string
  bgHexcodeDark: string
}

export interface Colors {
  hexCode: string
  nameEn: string
  nameMn: string
}
export interface Color {
  hexCode: string
  nameEn: string
  nameMn: string
}
export interface Product extends ProductMin {
  specsMn: Record<string, string>
  specsEn: Record<string, string>
  available: number
  hasLeasing?: boolean
  bonusDetailsMn?: string
  bonusDetailsEn?: string
  isParent: boolean
  createdAt: Date
  updatedAt: Date
  variations: Variation[]
  gifts: ProductGift[]
  rating: ProductRating
}
export interface ProductRating {
  point: number
  count: number
}
export interface ProductGift {
  id: number
  nameMn: string
  nameEn: string
  image: string
  descriptionMn: string
  descriptionEn: string
}
export interface Variation {
  id: number
  size: string
  color: string
  smsId: string
  price: number
}

export interface GetProductsRes {
  productList: Product[]
}
export type GetProducts = (
  params: ShopParams
) => Promise<ResponseBase<GetProductsRes>>
export type GetProductDetails = (
  id: string | string[] | undefined | number
) => Promise<ResponseBase<Product>>
export type GetSelectedCategory = (id: number) => Promise<ProductMin[]>

export const getProducts: GetProducts = async (params) => {
  const response = await shopCLient.get("/product", { params })
  return response.data
}

export const getProductDetails: GetProductDetails = async (
  id: string | string[] | undefined | number
) => {
  let param: string
  if (id !== undefined) {
    if (typeof id === "number") {
      param = id.toString()
    } else {
      if (Array.isArray(id)) {
        param = id[0]
      } else {
        param = id
      }
    }
    const response = await shopCLient.get(`/product/${param}`)
    return response.data
  }
}
